import React from 'react';
import { ScrollView, View } from 'react-native';
import BigParagraphWithIconLine from '../../../AuxiliaryComponent/BigParagraphWithIconLine';
import FullPageSimulator from '../../FullPageSimulator';
import ParagraphWithSmallSubTitle from '../../../AuxiliaryComponent/TextComponent/ParagraphWithSmallSubTitle';
import LargeBtnWithFilling from '../../../AuxiliaryComponent/ButtonComponent/LargeBtnWithFilling';
//= ========================================================================

const ConfirmTransferFP = ({
  globJSON,
  simPlatform,
  confirmation,
  subCategoryId = 'send_money_0',
  withoutIconLine,
  headlineText,
  blueStr,
  extendStrings,
  TopTitle,
  withOutLink,
  stringBottom,
  isConfirmation_split,
  withOutTopTitle,
  slideshowRefs = null,
  isLoan,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={headlineText}
    TopTitle={!withOutTopTitle && TopTitle}
    slideshowRefs={slideshowRefs}
    scrollDisabled
  >
    <ScrollView
      style={{ alignSelf: 'center' }}
      vertical
      pagingEnabled={false}
      showsVerticalScrollIndicator={false}
      scrollEnabled
    >
      <ParagraphWithSmallSubTitle
        globJSON={globJSON}
        simPlatform={simPlatform}
      />

      <View style={{ width: 1, height: 5 }} />

      <BigParagraphWithIconLine
        globJSON={globJSON}
        simPlatform={simPlatform}
        withoutIconLine={withoutIconLine}
        blueStr={blueStr}
        extendStrings={extendStrings}
        withOutLink={withOutLink}
        stringButtom={stringBottom}
        isConfirmation_split={isConfirmation_split}
        withAddPhoto={!isLoan && globJSON.configurations.services[subCategoryId].reference.customers_add_photo_enabled}
      />
      <LargeBtnWithFilling
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        inputText={isLoan ? confirmation.confirm_loan : confirmation.confirm}
      />
      <View style={{ width: 1, height: 10 }} />
    </ScrollView>
  </FullPageSimulator>

);
export default ConfirmTransferFP;
